module.exports = __webpack_public_path__ + "img/participou.23ac5a30.svg";